<template>
    <div 
        class="app-gradient-box shadow-sm"
        @click="gotoGradient(gid)"
    >
        <div class="body" :style="gradientContent"></div>
        <div class="title bg-white px-2 py-2 text-right">
            <small 
                v-if="devEnvironment"
                class="float-left mt-2"
                @click.stop="showPreview=true"
            >
            {{gradient.name}}</small>
            <button 
                class="btn btn-sm btn-link text-dark mr-2"
                @click="copyCSS"
            >
                Copy CSS
            </button>
            <button 
                class="btn btn-sm btn-link text-dark"
                @click="gotoGradient(gid)"    
            >
                Edit
            </button>
        </div>
        <template v-if="devEnvironment">
            <div 
                id="comparePreview" 
                class="collapse" 
                :class="{ show : showPreview}"
                @click.stop="showPreview=false"
            >
                <div class="row p-5">
                    <div class="col">
                        <div class="jumbotron" :style="gradientContent">
                            <h1>Dark Header Preview</h1>
                            <p class="lead">This is a default header unit with dark test, </p>
                            <p>This is smaller, more normal, non-lead text.  It should be easy to read.</p>		
                        </div>
                    </div>
                    <div class="col">
                        <div class="jumbotron text-light" :style="gradientContent" >
                            <h1>Light Header Preview</h1>
                            <p class="lead">This is a default header unit with light test, </p>		
                            <p>This is smaller, more normal, non-lead text.  It should be easy to read.</p>
                        </div>
                    </div>
                </div>
            </div> 
        </template>
    </div>
</template>

<script>
import gradients from '@/util/gradients.js'
import copyutils from '@/util/copyutils.js'

export default {
    props: ['gid', 'cid'],
    data(){
        return {
            showPreview: false,
            previewBackground: '',
        }
    },
    methods: {
        gotoGradient(gid){
            // this.$router.push({ name: 'gradient', params: {gid, cid: this.cid}})
            let path = `/collection/${this.cid}/gradient/${this.gid}`
            this.$router.push({path})
        },
        copyCSS(e){
            copyutils.copyGradientToClipboard(this.gradientContent, this.gradient.date);
            e.stopPropagation();
        }
    },
    computed: {
        gradient(){
            let g =  gradients.find((obj) => {
                return obj.date == this.gid;
            })
            return g;
        },
        gradientContent(){
            if(this.gradient.content.indexOf('background-image') != -1){
                return this.gradient.content; // Already has full CSS styles
            }
            else {
                return `background-image: ${this.gradient.content};`
            }
        },
        devEnvironment(){
            return process.env.NODE_ENV == 'development'
        }
    }
}
</script>

<style lang="scss">
.app-gradient-box {
    $bradius: 4px;
    border-radius: $bradius;
    cursor: pointer;
    transition: .5s all;

    .body {
        height: 175px;
        border-top-right-radius: $bradius;
        border-top-left-radius: $bradius;

        transition: .5s all;
        background-size: 100% 100%;
        // background-position: 0 0;
        &:hover {
            background-size: 112% 112%;
        }
    }
    .title {
        border-bottom-right-radius: $bradius;
        border-bottom-left-radius: $bradius;
    }

    &:hover {
        margin-top: -4px;
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    }
    #comparePreview {
        cursor: pointer;
        background-color: white;
        position: fixed; 
        z-index: 4;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

}
</style>